export const dialogBox = `
    <div class="text"><span>{{winner}}</span> wins ! <span>{{looser}}</span> is now crab food !</div>
    <button id="new-game">New game</button>
`;
